import { AuditChannel } from "@common/types/auditLog";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { toVisibleChannel } from "@components/history/components/historyActivityFilters";

export function useVisibleActivityChannel(
    channel: AuditChannel | null | undefined,
): AuditChannel | undefined {
    const {
        activityUpdatedThroughFilter: isChannelAttributionEnabled,
        agentRuns: isAgentRunsEnabled,
    } = useTypedFlags();

    return toVisibleChannel({
        channel,
        isChannelAttributionEnabled,
        isAgentRunsEnabled,
    });
}
